import type { StatusBadgeTone } from '../../atoms/StatusBadge';
import type { StudioTemplateCard } from 'types/studio';

/**
 * The one place a Studio template's lifecycle status maps to a `StatusBadgeAtom` tone.
 * The gallery card and the drawer header both render the badge, and a divergent mapping
 * would show the same template as two different states in two places.
 *
 * `null` (a type with no `template_version` representation) has no tone — the caller
 * renders no badge at all rather than inventing one.
 */
export function studioStatusTone(status: StudioTemplateCard['status']): StatusBadgeTone | null {
  if (status === 'draft') return 'warn';
  if (status === 'published') return 'success';
  return null;
}
